import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';

interface Props {
  href?: string;
  text: any;
  className?: string;
  target?: string;
  icon?: any;
  sm?: any;
  md?: any;
  custom?: any;
  onMouseEnter?: React.MouseEventHandler<Element>;
}

const CustomButton = ({
  href,
  text,
  sm,
  md,
  className = '',
  target = '',
  onMouseEnter,
  icon,
  custom,
}: Props) => {
  const theme = useTheme();

  return (
    <Button
      component="a"
      color="primary"
      href={href}
      variant="text"
      className={className}
      onMouseEnter={onMouseEnter}
      target={target}
      startIcon={icon}
      sx={{
        color: theme.palette.text.primary,
        textTransform: 'uppercase',
        mx: 0.75,
        fontSize: { sm, md },
        '&:active': {
          color: theme.palette.primary.main,
        },
        '&:hover': {
          color: theme.palette.primary.main,
        },
        custom,
      }}
    >
      <Box
        component="span"
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    </Button>
  );
};

export default CustomButton;
